import React, { useState } from 'react';
import { Box, Text, Flex } from 'rebass';
import Wrapper from './Wrapper';
import useHistory from 'app/hooks/history';

const YES_IS_GIFT = 'Yes — I’m gifting it to a parent'
const NO_GIFT = 'No — I’ll be creating the book'

const OrderType = () => {
    const [selectedValue, setSelectedValue] = useState(null);
    const { push } = useHistory();

    async function onSubmit(e) {
        const queryParams = new URLSearchParams(window.location.search);
        const customerEmail = queryParams.get('customerEmail');
        const orderQuantity = queryParams.get('orderQuantity');
        const orderId = queryParams.get('orderId');
        const shopifyOrderId = queryParams.get('shopifyOrderId');
        if (selectedValue === YES_IS_GIFT) {
            push(`/gift?step=3&orderQuantity=${orderQuantity}&orderId=${encodeURIComponent(orderId)}&shopifyOrderId=${encodeURIComponent(shopifyOrderId)}`)
        } else if (selectedValue === NO_GIFT) {
            push(`/babys-first-year/get-started?step=1&customerEmail=${encodeURIComponent(customerEmail)}&orderQuantity=${orderQuantity}&orderId=${encodeURIComponent(orderId)}&shopifyOrderId=${encodeURIComponent(shopifyOrderId)}`)
        }
    }

    return (
        <Wrapper
            onSubmit={onSubmit}
            showFooter
            percentComplete={0}
            bg="aliceBlue"
        >
            <Box m="auto" my="6.7%" mt="2.35%" width={['92%', '92%', '33%']}>
                <Text mb="30px" color="codGrey"
                    fontFamily="Bitter"
                    fontSize={30}
                    lineHeight="120%"
                    letterSpacing="-0.18px"
                    textAlign="center">
                    Is this a gift?
                </Text>

                <Flex flexDirection="column" >
                    {[
                        YES_IS_GIFT,
                        NO_GIFT
                    ].map(option => {
                        const isSelected = selectedValue === option

                        return <Flex
                            mb='2.2%'
                            flexDirection="column"
                            justifyContent="center" sx={{ border: `1.5px solid ${isSelected ? '#724086' : '#D1D1D1'}`, cursor: 'pointer', borderRadius: '23px' }}
                            alignItems="center"
                            bg={isSelected ? "#F5EEF8" : "white"}
                            px={["20px"]}
                            py={["10px"]}
                            height="max-content"
                            onClick={() => {
                                if (isSelected)
                                    setSelectedValue(null)
                                else
                                    setSelectedValue(option)
                            }}
                        >
                            <Text fontFamily="Poppins" color={isSelected ? "#724086" : "mineShaft"} maxWidth={320} textAlign="center" fontSize={18} lineHeight={"24px"} letterSpacing={"-0.6px"}>{option}</Text>
                        </Flex>
                    })}
                </Flex>

            </Box>
        </Wrapper>
    )
};

export default OrderType;
